import setup from "app/setup/application";
import Reducer, {createInitialState} from "./reducer";
import createRoutes from "./routes";
import "./assets/style.scss";

export default setup({createInitialState, createRoutes, Reducer});
